import { Box } from '@mui/material';
import PageHeader from '../commons/PageHeader';

function NotFound() {
  return (
    <>
      <PageHeader title='Are you lost?' />
      <Box sx={{ width: { xs: '100%', sm: '50%', md: '30%' }, m: 'auto' }}>
        <img src='/puppy.jpg' width='100%' alt='Lost Puppy' />
      </Box>
    </>
  );
}

export default NotFound;
